import { FC, useState, useCallback } from 'react'
import styles from 'components/features/pfm/AccountActions/AccountActions.styl'
import cn from 'classnames'
import { ActionIcon } from 'components/features/pfm/ActionMenu/ActionIcon'
import { AccountActionsMenu } from 'components/features/pfm/AccountActionsMenu/AccountActionsMenu'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

export type AccountActionsProps = {
  accountInfo: MixedAccountsTableItem
  menuDirection?: 'above' | 'below'
}

export const AccountActions: FC<AccountActionsProps> = (props) => {
  const { accountInfo, menuDirection = 'below' } = props
  const { providerAccountState } = accountInfo
  const { actions } = providerAccountState
  const [isActionsMenuShown, setIsActionMenuShown] = useState(false)

  const handleShowActionsMenu = useCallback(() => {
    setIsActionMenuShown(true)
  }, [setIsActionMenuShown])

  const handleHideActionsMenu = useCallback(() => {
    setIsActionMenuShown(false)
  }, [setIsActionMenuShown])

  if (!actions) {
    return null
  }

  return (
    <div className={ cn(styles.actionMenuContainer, styles[menuDirection]) }>
      <button className={ styles.actionMenuButton } onClick={ handleShowActionsMenu }>
        <ActionIcon className={ styles.actionButton } />
      </button>
      <div
        className={ cn(styles.actionMenu, isActionsMenuShown && styles.actionMenuShown) }
      >
        <AccountActionsMenu
          accountInfo={ accountInfo }
          onHide={ handleHideActionsMenu }
        />
      </div>
    </div>
  )
}
